import Vue from 'vue'
import Vuex from 'vuex'
import alert from '@/store/alert'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    alert
  }
})
